import {
  TeamRolesApi,
  TeamRolesClient,
} from '@agilelab/plugin-wb-team-roles-common';
import {
  ApiRef,
  createApiFactory,
  createApiRef,
  createPlugin,
  discoveryApiRef,
} from '@backstage/core-plugin-api';

export const teamRolesApiRef: ApiRef<TeamRolesApi> = createApiRef({
  id: 'plugin.wb-team-roles',
});

/** @public */
export const teamRolesPlugin = createPlugin({
  id: 'wb-team-roles',
  apis: [
    createApiFactory({
      api: teamRolesApiRef,
      deps: { discoveryApi: discoveryApiRef },
      factory: ({ discoveryApi }) => new TeamRolesClient(discoveryApi),
    }),
  ],
});
